// What happens on stage, as the phones and the panel keep it: the last clients' jackpot,
// the last number jackpot, and which of the two is on screen

export const EMPTY_DRAWS = { buyers: null, jackpot: null, latest: null };

// 7 -> "007": the machine always shows three digits
export const pad = (number) => String(number).padStart(3, '0');

const parseList = (json) => {
  try {
    const value = JSON.parse(json || '[]');
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

// Clients' jackpots arrive as `app:BUYERS` room events, launched from the admin panel
export const buyersFromEvent = ({ attributes }) => ({
  game: 'buyers',
  id: attributes.id,
  title: attributes.title,
  winner: attributes.winner,
  names: parseList(attributes.names), // the names the reel shows travel as JSON in the event
  total: Number(attributes.total),
  duration: Number(attributes.duration) || 6000,
  live: true,
});

// Jackpots arrive as `app:JACKPOT` room events
export const jackpotFromEvent = ({ attributes }) => ({
  game: 'jackpot',
  id: attributes.id,
  number: attributes.number, // three digits, "007"
  from: Number(attributes.from),
  to: Number(attributes.to),
  duration: Number(attributes.duration) || 6000,
  live: true,
});

// A draw as the backend lists it (the panel state, or the last one in /history), shown
// without animating. Anything that is not a number jackpot is a clients' jackpot, the old
// wheel's draws included
export const drawFromRecord = (record) =>
  record.game === 'jackpot'
    ? { game: 'jackpot', id: record.id, number: pad(record.number), from: record.from, to: record.to, live: false }
    : { game: 'buyers', id: record.id, title: record.title, winner: record.winner, total: record.total, names: [], live: false };

// A live draw takes the stage; one recovered from the history never replaces what is already there
export const withDraw = (current, draw) => {
  if (!draw.live && current[draw.game]) return current;
  const latest = draw.live || !current.latest ? draw.game : current.latest;
  return { ...current, [draw.game]: draw, latest };
};
